export function capitalizeFirstLetter(val: string) {
	if (!val) return "";
	return String(val).charAt(0).toUpperCase() + String(val).slice(1);
}

/**
 * Check if text contains only Latin characters (English alphabet)
 * @param text - Text to check
 * @returns true if text contains only Latin characters, numbers, spaces and common punctuation
 */
export function isLatinText(text: string): boolean {
	if (!text) return true;
	// Only Latin letters (a-z, A-Z), numbers, spaces, and common punctuation
	const latinRegex = /^[a-zA-Z0-9\s.,!?;:'"()[\]{}\-_/@#$%&*+=<>~`|\\]+$/;
	return latinRegex.test(text);
}

/**
 * Check if text contains any non-Latin characters
 * @param text - Text to check
 * @returns true if text contains non-Latin characters (e.g., Cyrillic, Chinese, etc.)
 */
export function hasNonLatinCharacters(text: string): boolean {
	return !isLatinText(text);
}
